import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@/app/hooks";
import { patchField } from "@/features/configuration/slice";
import { useSetShopActivationMutation } from "@/features/shell/api";
import { selectCurrentShopId, selectPlanValue, selectShopIsActive } from "@/features/shell/legacySelectors";
import { StatusBadge } from "@/shared/layout";
import { Toggle } from "@/shared/ui";

export function PublishToggle() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const shopId = useAppSelector(selectCurrentShopId);
  const isActive = useAppSelector(selectShopIsActive);
  const planActive = Boolean(useAppSelector(selectPlanValue).isActive);
  const [setActivation] = useSetShopActivationMutation();

  const activationToggle = async (value: boolean) => {
    if (!planActive || shopId === undefined) return;
    await setActivation({ id: shopId, active: value }).unwrap();
    dispatch(patchField({ path: ["is_active"], value }));
    // la rilettura di /shops (tag Shop invalidato) aggiorna websites tramite il ponte
  };
  const toBillingInfo = () => {
    if (!planActive) navigate("/billing/information");
  };

  return (
    <div
      className="publish-control"
      onClick={toBillingInfo}
      title={planActive ? undefined : t("saveChanges.locked")}
    >
      <StatusBadge tone={planActive && isActive ? "success" : planActive ? "neutral" : "warning"}>
        {planActive
          ? isActive
            ? t("saveChanges.published")
            : t("saveChanges.notPublished")
          : t("saveChanges.locked")}
      </StatusBadge>
      <Toggle checked={isActive} disabled={!planActive} onChange={(value) => void activationToggle(value)} />
    </div>
  );
}
